import React, { useEffect } from 'react';
import { CircleAlert } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../atoms/dialog';

/**
 * MobileOnlyModal
 * Non-dismissible modal for mobile devices, following platform UI/UX
 */
export const MobileOnlyModal: React.FC = () => {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <>
      {/* Background image layer - z-[9999] to cover everything including sidebar */}
      <div className="fixed inset-0 z-[9999] bg-cover bg-center bg-no-repeat bg-[url('https://s3.us-east-1.amazonaws.com/app-test.ideoz.ai/mobileBg.png')]" />
      {/* Light gray overlay with 50% opacity */}
      <div className="fixed inset-0 z-[9999] bg-gray-400/50" />
      
      <Dialog open={true} onOpenChange={() => {}}>
        <DialogContent className="fixed left-[50%] top-[50%] z-[10000] grid w-full translate-x-[-50%] translate-y-[-50%] gap-5 border bg-white p-6 rounded-lg py-5 px-4 max-w-[300px] shadow-none">
          <DialogHeader className="flex gap-3 items-start">
            <CircleAlert size={24} color="#101828" />
            <DialogTitle className="text-base font-semibold text-gray-800 text-left">
              Optimized for Desktop or Tablet
            </DialogTitle>
          </DialogHeader>
          <p className="text-sm text-gray-800 text-left">
            We don't currently support mobile devices. For the best experience, please use a tablet or desktop.
          </p>
        </DialogContent>
      </Dialog>
    </>
  );
};